module.exports = __webpack_public_path__ + "img/_015.4ba11892.png";